<template>
    <div class="customer-form">
        <h3>Kundendaten</h3>

        <div class="row mt-3">
            <div v-if="!isGenderCompany" class="col-md-6">
                <csp-form-group-radio :form="customerForm" :options="genderOptions"
                    property="gender" required/>
            </div>

            <div v-if="!isGenderPerson" class="col-md-6">
                <csp-form-group-input :form="customerForm" property="companyName" :required="isGenderCompany"/>
            </div>

            <!-- Force next columns to break to new line -->
            <div class="w-100"/>

            <div class="col-md-6">
                <csp-form-group-input :form="customerForm"
                    :label-property="firstNameLabel" :potentially-required="isFleetOrMajorCustomer"
                    property="firstName" :required="isNameRequired"/>
            </div>

            <div class="col-md-6">
                <csp-form-group-input :form="customerForm"
                    :label-property="lastNameLabel" :potentially-required="isFleetOrMajorCustomer"
                    property="lastName" :required="isNameRequired"/>
            </div>

            <div class="col-md-6">
                <csp-form-group-input :form="customerForm" property="street" required/>
            </div>

            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-4">
                        <csp-form-group-input :form="customerForm" property="postalCode" required/>
                    </div>

                    <div class="col-md-8">
                        <csp-form-group-input :form="customerForm" property="place" required/>
                    </div>
                </div>
            </div>

            <div class="col-12 mt-3">
                <h3>Wie können wir Sie am besten erreichen?</h3>
            </div>

            <div class="col-md-6">
                <csp-form-group-input :form="customerForm" :potentially-required="isFleetOrMajorCustomer"
                    property="phoneGeneric" required/>
            </div>

            <div class="col-md-6">
                <csp-form-group-input :form="customerForm" :potentially-required="isFleetOrMajorCustomer"
                    property="email" :required="isFleetOrMajorCustomer" type="email"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Form from '@form/Form';
    import GenderEnum from '@js/enums/GenderEnum';
    import {buildOptionsGenderPerson} from '@js/functions/form/select';

    export default {
        props: {
            customerForm: {
                type: Form,
                required: true,
            },
            isFleetOrMajorCustomer: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
                genderOptions: [],
            }
        },
        computed: {
            firstNameLabel() {
                if (this.isGenderCompany) {
                    if (this.isFleetOrMajorCustomer) {
                        return 'driverFirstName';
                    }

                    return 'companyFirstName';
                }
                return '';
            },
            isGenderCompany() {
                return this.customerForm.getDataOfProperty('gender') === GenderEnum.COMPANY;
            },
            isGenderPerson() {
                const gender = this.customerForm.getDataOfProperty('gender');
                return gender === GenderEnum.MALE || gender === GenderEnum.FEMALE;
            },
            isNameRequired() {
                return !this.isGenderCompany || this.isFleetOrMajorCustomer;
            },
            lastNameLabel() {
                if (this.isGenderCompany) {
                    if (this.isFleetOrMajorCustomer) {
                        return 'driverLastName';
                    }

                    return 'companyLastName';
                }
                return '';
            },
        },
        async mounted() {
            this.genderOptions = await buildOptionsGenderPerson();
        },
    }
</script>
